import React from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import * as R from "ramda";

import appartement from './../../../assets/images/svg/090-flats.svg';
import maison from './../../../assets/images/svg/069-home.svg';
import palace from './../../../assets/images/svg/093-palace.svg';
import hotel from './../../../assets/images/svg/087-hotel.svg';
import peniche from './../../../assets/images/svg/091-house-2.svg';
import divers from './../../../assets/images/svg/092-camping-tent.svg';

import union from './../../../assets/images/svg/051-parents.svg';
import locataire from './../../../assets/images/svg/069-home.svg';
import activite from './../../../assets/images/svg/035-id-card.svg';
import retraite from './../../../assets/images/svg/111-rocking-chair.png';
import pole from './../../../assets/images/svg/066-job-interview.svg';
import autre from './../../../assets/images/svg/034-clipboard.svg';

import liendirect from './../../../assets/images/svg/049-family.svg';
import autres from './../../../assets/images/svg/051-parents.svg';

import celibataireW from './../../../assets/images/svg/001-W-celibataire.svg';
import unionsW from './../../../assets/images/svg/001-W-unions.svg';
import divorceeW from './../../../assets/images/svg/001-W-divorcee.svg';
import veuveW from './../../../assets/images/svg/001-W-veuve.svg';

import celibataireM from './../../../assets/images/svg/001-M-celibataire.svg';
import unionsM from './../../../assets/images/svg/001-M-unions.svg';
import divorceeM from './../../../assets/images/svg/001-M-divorcee.svg';
import veuveM from './../../../assets/images/svg/001-M-veuve.svg';
import { inviteUserRepresentative } from '../../../actions/backoffice/user';




export const DonnesProfile = ({ email, phoneNumber, firstName, lastName, birthDate, processNumber, civilStatus, gender, professionalSituation, address, mainRepresentative, representatives, userDocuments, isDeceased }) => {
	const hideModal = () => {
		$('.modal').modal("hide");
	};

	const dispatch = useDispatch();

	const familyOptionsToEN = { celibataire: 'Single', mariee: 'Married', divorcee: 'Divorced', veuve: 'Widowed', libre: 'FreeUnion', civilUnion: 'CivilUnion' };
	const familyOptionsToFR = { single: 'Célibataire', married: 'Mariée', divorced: 'Divorcee', widowed: 'Veuve', freeUnion: 'Libre', civilUnion: 'CivilUnion' };
	//const familyOptions = { celibataire: 'Single', mariee: 'Married', divorcee: 'Divorced', veuve: 'Widowed', libre: 'FreeUnion', civilUnion: 'CivilUnion' }

	const familyStatusText = {
		Married: { 'Male': 'Marié', 'Female': 'Mariée' },
		Divorced: { 'Male': 'Divorcé', 'Female': 'Divorcée' },
		Widowed: { 'Male': 'Veuf', 'Female': 'Veuve' },
		CivilUnion: { 'Male': 'Pacsé', 'Female': 'Pacsée' },
		FreeUnion: { 'Male': 'Union Libre', 'Female': 'Union Libre' },
		Single: { 'Male': 'Célibataire', 'Female': 'Célibataire' }
	};
	const genders = { male: 'Male', female: 'Female' };

	const familyOptionsEN = { single: 'Single', married: 'Married', divorced: 'Divorced', widowed: 'Widowed', freeUnion: 'FreeUnion', civilUnion: 'CivilUnion' };
	const representativeType = { child: 1, parent: 2, sibling: 3, spouse: 4, other: 5 };

	const professionOptions = { Retired: 'Retired', Employed: 'Employed', Unemployed: 'PoleEmploi', OtherActivity: 'OtherActivity' };
	const professionOptionsText = { Retired: 'RETRAITÉ(E)', Employed: 'EN ACTIVITÉ(E)', PoleEmploi: 'À FRANCE TRAVAIL', OtherActivity: 'AUTRE ACTIVITÉ' };

	const estateType = { appartement: 'Apartment', house: 'House', castle: 'Castle', hotel: 'Hotel', boat: 'Houseboat', camp: 'Other' };
	const estateTypeFR = { Apartment: 'Appartement', House: 'Maison', Castle: 'Châteu', Hotel: 'Hotel', Boat: 'Péniche', Camp: 'Divers' };

	return (
		<div className="modal fade px-0" id="DonnesProfile" aria-labelledby="DonnesProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2 container-screen">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">User Profile</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="DonnesProfileLabel">données personnelles</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<form className="block" noValidate>
							<header className="alert bg-common rounded-bottom-left-sm rounded-top-right-sm mb-sm px-3">
								<h2 className="h1 font-weight-demi ls-n1 text-primary mb-sm mt-1">{firstName} {lastName}</h2>
								
								<div className="row gx-2 gy-1">
									{/* <div className="col-auto">
										<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">Email</div>
										<p className="h5 mb-auto">{email}</p>
									</div>
									<div className="col-auto">
										<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">Téléphone</div>
										<p className="h5 mb-auto">{phoneNumber}</p> 
									</div> */}
									
									{userDocuments.items.map((doc, index) => (
										<div className="col-auto" key={doc.secondTitle + index}>
											<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">D. {doc.secondTitle}</div>
											<div className="progress progress-lg mb-auto bg-common">
												<div className="progress-bar bg-primary o-10 rounded-inherit" role="progressbar" style={{ width: `${doc.percent}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
												<div className="progress-text my-auto text-uppercase o-60" role="progressbar">{doc.done}/{doc.num}</div>
											</div>
										</div>
									))
									}

								</div>
							</header>
							<div className="row gx-1 gx-lg-0 mb-sm">
								{/* <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={union} alt="maison" />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyOptionsToFR[civilStatus?.toLowerCase()]}</p>
								</div> */}
								{civilStatus === familyOptionsEN.single && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? celibataireM : celibataireW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{civilStatus === familyOptionsEN.married && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? unionsM : unionsW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{civilStatus === familyOptionsEN.divorced && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? divorceeM : divorceeW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{civilStatus === familyOptionsEN.widowed && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? veuveM : veuveW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{civilStatus === familyOptionsEN.freeUnion && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? unionsM : unionsW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{civilStatus === familyOptionsEN.civilUnion && <div className="col-auto col-lg flex-row align-items-center justify-content-md-start">
									<img className="img-fluid mr-3 h-gutter py-border" src={gender === genders.male ? unionsM : unionsW} alt={familyStatusText[civilStatus][gender]} />
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{familyStatusText[civilStatus][gender]}</p>
								</div>}
								{address && <div className={"col-auto  flex-row align-items-center" + (professionalSituation.length > 1 ? "  col-lg" : " justify-content-md-center mx-auto")}>
									{address.addressType === estateType.appartement && <img className="img-fluid mr-3 h-gutter py-border" src={appartement} alt={estateTypeFR[address.addressType]} />}
									{address.addressType === estateType.house && <img className="img-fluid mr-3 h-gutter py-border" src={maison} alt={estateTypeFR[address.addressType]} />}
									{address.addressType === estateType.castle && <img className="img-fluid mr-3 h-gutter py-border" src={palace} alt={estateTypeFR[address.addressType]} />}
									{address.addressType === estateType.hotel && <img className="img-fluid mr-3 h-gutter py-border" src={hotel} alt={estateTypeFR[address.addressType]} />}
									{address.addressType === estateType.boat && <img className="img-fluid mr-3 h-gutter py-border" src={peniche} alt={estateTypeFR[address.addressType]} />}
									{address.addressType === estateType.camp && <img className="img-fluid mr-3 h-gutter py-border" src={divers} alt={estateTypeFR[address.addressType]} />}
									{/* <p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">locataire du maison</p> */}
									<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate">{address?.addressLine1},<br /> {address?.postalCode}, {address?.city}</p>
								</div>
								}
								{professionalSituation.length > 1 && <div className="col-12 my-2"></div>}
								{
									professionalSituation.map(profession => (

										<div className={"col-auto col-lg flex-row align-items-center" + (professionalSituation.length <= 1 ? " justify-content-md-end" : "")} key={profession} >
											{professionOptions.Employed === profession && <img className="img-fluid mr-3 h-gutter py-border" src={activite} alt="maison" />}
											{professionOptions.Retired === profession && <img className="img-fluid mr-3 h-gutter py-border" src={retraite} alt="maison" />}
											{professionOptions.Unemployed === profession && <img className="img-fluid mr-3 h-gutter py-border" src={pole} alt="maison" />}
											{professionOptions.OtherActivity === profession && <img className="img-fluid mr-3 h-gutter py-border" src={autre} alt="maison" />}
											<p className="h6 o-70 text-uppercase font-weight-bold my-auto text-truncate" key={profession}>{professionOptionsText[profession]}</p>
										</div>
									))
								}
							</div>
							<div className="row gx-1">
								<div className="col h-inherit">
									{!R.isNil(mainRepresentative) &&
										<div className="card border border-common mb-3">
											<div className="card-header px-3 pt-3 pb-0">
												<h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">Referent principal</h2>
												<hr className="mb-0" />
											</div>
											<div className="card-body p-3">
												<h4 className="h6 font-weight-bolder">{mainRepresentative.gender === 2 ? "Monsieur" : "Madame"}</h4>
												<h3 className="h3 font-weight-regular mb-4">{mainRepresentative.lastName} {mainRepresentative.firstName}</h3>
												{mainRepresentative.representativeType < 5 ?
													<div className="card text-capitalize flex-row align-items-center mb-3">
														<img className="img-fluid my-auto mb-2 h-5 py-1" src={liendirect} alt={"lien familial direct"} />
														<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
													</div>
													:
													<div className="card text-capitalize flex-row align-items-center mb-3">
														<img className="img-fluid my-auto mb-2 h-5 py-1" src={autres} alt={"autres"} />
														<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
													</div>
												}
												<div className="flex-row align-items-start mb-3">
													<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
													<p className="h5 lh-copy my-auto">{new Intl.DateTimeFormat('fr-FR', { day: "numeric", month: "long", year: "numeric" }).format(mainRepresentative.birthDate)}</p>
												</div>
												<div className="flex-row align-items-start mb-3">
													<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
													{
														R.isNil(mainRepresentative.addresses[0]) ?
															<p className="h5 lh-copy my-auto">&nbsp;</p>
														:
															<p className="h5 lh-copy my-auto">{mainRepresentative.addresses[0].addressLine1}<br /> {mainRepresentative.addresses[0].postalCode} {mainRepresentative.addresses[0].city}, {mainRepresentative.addresses[0].country}</p>
													}
												</div>
												{
														!R.isNil(mainRepresentative.email) && mainRepresentative.email !== "" ?
															<div className="flex-row align-items-start">
																<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
																<p className="h5 lh-copy my-auto">{mainRepresentative.email}</p>
															</div>
														:
															''
													}
											</div>
											{/* <div className="card-footer text-center border-common bg-common--hover text-primary--hover mt-2">
												<button type="button" className={"btn text-inherit loading-btn btn-if align-items-center p-0"} name="resend" onClick={() => dispatch(inviteUserRepresentative(mainRepresentative.id))}>
													<span className="aling-middle o-80">Renvoyer invitation</span>
													<i className="eva eva-email-outline ml-2 h4 my-auto lh-1 aling-middle"></i>
													<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
												</button>
											</div> */}
										</div>}
								</div>
								<div className="col h-inherit">
									{!R.isEmpty(representatives) &&

										representatives.map(representative => (
											<div className="card border border-common mb-3" key={representative.id}>
												<div className="card-header px-3 pt-3 pb-0">
													<h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">autre Referent</h2>
													<hr className="mb-0" />
												</div>
												<div className="card-body p-3">
													<h4 className="h6 font-weight-bolder">{representative.gender === 2 ? "Monsieur" : "Madame"}</h4>
													<h3 className="h3 font-weight-regular mb-4">{representative.lastName} {representative.firstName}</h3>
													{representative.representativeType < 5 ?
														<div className="card text-capitalize flex-row align-items-center mb-3">
															<img className="img-fluid my-auto mb-2 h-5 py-1" src={liendirect} alt={"lien familial direct"} />
															<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">lien familial direct</h2>
														</div>
														:
														<div className="card text-capitalize flex-row align-items-center mb-3">
															<img className="img-fluid my-auto mb-2 h-5 py-1" src={autres} alt={"autres"} />
															<h2 className="h6 font-weight-bolder ml-2 pl-1 mb-0 text-uppercase">autres</h2>
														</div>
													}
													<div className="flex-row align-items-start mb-3">
														<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
														<p className="h5 lh-copy my-auto">{new Intl.DateTimeFormat('fr-FR', { day: "numeric", month: "long", year: "numeric" }).format(representative.birthDate)}</p>
													</div>
													<div className="flex-row align-items-start mb-3">
														<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
														<p className="h5 lh-copy my-auto">{representative.addresses[0].addressLine1} <br />{representative.addresses[0].postalCode} {representative.addresses[0].city}, {representative.addresses[0].country}</p>
													</div>
													{
														!R.isNil(representative.email) && representative.email !== "" ?
															<div className="flex-row align-items-start">
																<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
																<p className="h5 lh-copy my-auto">{representative.email}</p>
															</div>
														:
															''
													}
													
												</div>
												<div className="card-footer text-center border-common bg-common--hover text-primary--hover mt-2">
													<button type="button" className={"btn text-inherit loading-btn btn-if align-items-center p-0"} name="resend" onClick={() => dispatch(inviteUserRepresentative(representative.id))}>
														<span className="aling-middle o-80">Renvoyer invitation</span>
														<i className="eva eva-email-outline ml-2 h4 my-auto lh-1 aling-middle"></i>
														<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
													</button>
												</div>
											</div>
										))
									}
								</div>
							</div>
							{/* <div className="card border border-common">
								<div className="card-header px-3 pt-3 pb-0">
									<h2 className="h4 text-secondary text-uppercase font-weight-bolder my-auto">Enfants</h2>
									<hr className="mb-0" />
								</div>
								<div className="card-body p-3">
									<div className="grid grid-lg-tight gx-2 gy-3">
										<div className="col h-inherit">
											<h4 className="h6 font-weight-bolder">Monsieur</h4>
											<h3 className="h3 font-weight-regular mb-4">data.lastName + firstName</h3>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">2 mars 1960</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">71, rue de Raymond Poincaré <br />11100 NARBONNE, France</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">theundertaker@rhyta.com </p>
											</div>
											<div className="flex-row align-items-start">
												<i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">01.76.91.27.98</p>
											</div>
										</div>
										<div className="col h-inherit">
											<h4 className="h6 font-weight-bolder">Monsieur</h4>
											<h3 className="h3 font-weight-regular mb-4">data.lastName + firstName</h3>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">4 juin 1945</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">71, rue de Raymond Poincaré <br />11100 NARBONNE, France</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">-</p>
											</div>
											<div className="flex-row align-items-start">
												<i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">+33 01.42.99.41.42</p>
											</div>
										</div>
										<div className="col h-inherit">
											<h4 className="h6 font-weight-bolder">Madame</h4>
											<h3 className="h3 font-weight-regular mb-4">data.lastName + firstName</h3>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-calendar-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">4 juin 1945</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">71, rue de Raymond Poincaré <br />11100 NARBONNE, France</p>
											</div>
											<div className="flex-row align-items-start mb-3">
												<i className="eva lh-copy eva-email-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">-</p>
											</div>
											<div className="flex-row align-items-start">
												<i className="eva lh-copy eva-phone-outline mr-2 o-50"></i>
												<p className="h5 lh-copy my-auto">+33 05.68.79.41.13</p>
											</div>
										</div>
									</div>
								</div>
							</div> */}

						</form>
					</div>
					<div className="modal-footer">
						{/* <Link to="/facilita/:user/declarer/" type="button" className="btn btn-primary mr-auto" onClick={() => {
							hideModal();
						}} data-toggle="modal" data-target="#processDeces">Client décèdé</Link> */}
						{/* {isDeceased ? "" : <button type="button" className="btn btn-primary mr-auto" onClick={() => { hideModal(); }} data-toggle="modal" data-target="#processDeces">Client décèdé</button>} */}
						<button type="button" className="btn btn-faded" data-dismiss="modal">Fermer</button>
					</div>
				</div>
			</div>
		</div>
	);
};